/*
 * The only purpose of this file is to kick off the application's top-level
 * controller at the appropriate time. All other code should be written as
 * separate components in their own files.
 *
 * @fileOverview Index.js
 */

import 'es6-promise/auto';
import { Store } from 'store/vuexStore';
import Main from './main';

Main.buildVue(Store);
